import { tns } from 'tiny-slider/src/tiny-slider';
import Tab from '../../../utils/Tab';
import SalesPartnerHowDoesItWorkSlider from './SalesPartnerHowDoesItWorkSlider';

class SalesPartner {
  constructor() {
    this.main = document.getElementById('sales_partner');
    this._sliderWork = new SalesPartnerHowDoesItWorkSlider();
    this._sliderCampaign = null;
    this._tabBillboardTypes = this.main.querySelectorAll('.tab_billboard_type').forEach(tab => new Tab(tab));

    history.scrollRestoration = 'manual';
    document.addEventListener('beforeunload', () =>
      setTimeout(() => window.scrollTo(0, 0), 10)
    );

    this._initSliderCampaign();

    window.addEventListener('resize', this._onResize.bind(this));
  }

  // BILLBOARD TYPES SLIDER
  _initSliderCampaign() {
    this._sliderCampaign = tns({
      container: '#slider_campaign .carousel__slider',
      nav: false,
      controls: false,
      mouseDrag: true,
      speed: 500,
      loop: false,
      autoplay: false,
      gutter: 20,
      autoplayButtonOutput: false,
      autoplayTimeout: 2000,
      slideBy: 1,
      preventScrollOnTouch: 'auto',
      swipeAngle: 45,
      items: 1.6,
      responsive: {
        767: {
          items: 2.6
        },
        1023: {
          items: 4,
        },
        1200: {
          items: 5,
        }
      }
    });
  }

  _onResize() {
    // Update Slider Work
    this._initSliderWork();
  }
}

export default SalesPartner;
